import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { faqData } from "./headerConstant";

export default function Faq() {
	const [expanded, setExpanded] = React.useState(false);

	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};

	return (
		<div>
			{faqData.map((item) => (
				<Accordion
					key={item.id}
					expanded={expanded === item.id}
					onChange={handleChange(item.id)}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls={`${item.id}-content`}
						id={`${item.id}-header`}>
						{/* <Typography component="span" sx={{ width: "33%", flexShrink: 0 }}>
							{item.title}
						</Typography> */}
						{item.subtitle && (
							<Typography component="span" sx={{ color: "text.secondary" }}>
								{item.subtitle}
							</Typography>
						)}
					</AccordionSummary>
					<AccordionDetails>
						<Typography>{item.content}</Typography>
					</AccordionDetails>
				</Accordion>
			))}
		</div>
	);
}




